import { getRequest, postRequest, putRequest, deleteRequest } from ".";

export const getNewsResources = (type) => {
  return getRequest(`/user/scrape-news?type=${type}`);
};

export const addAdditionalServices = (payload) => {
  return postRequest(`/user/additional-services`, payload);
}

export const delAdditionalServices = (payload) => {
  return deleteRequest(`/user/del-additional-services`, payload);
}

export const markedFavouriteUnfavourite = (payload) => {
  return putRequest(`/user/additional-services/favourite`, payload);
}

export const getFavouriteServices = () => {
  return getRequest(`/user/additional-services/scrape-favourites`);
}

export const addFinanceService = (payload) => {
  return postRequest('/additional/services/add-finance-service', payload);
}

export const delFinanceService = (payload) => {
  return deleteRequest('/additional/services/del-finance-service', payload);
}

export const getFinanceService = () => {
  return getRequest('/additional/services/get-finance-service');
}

export const getResourceOptions = () => {
  return getRequest('/resource/get-resources-by-types');
}

export const getPresignedUrl = (payload) => {
  return postRequest('/resource/get-presigned-url',payload);
}

export const getFinanceOptions = () => {
  return getRequest("/additional/services/finance-options");
};

export const getMedicalConsent = () => {
  return getRequest("/additional/services/medical-consent");
};

export const updateMedicalConsent = (medicalConsent) => {
  return putRequest("/additional/services/medical-consent", { medicalConsent });
};